"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FinderBase = _interopRequireDefault(require("./FinderBase"));

var _FinderHeader = _interopRequireDefault(require("./FinderHeader"));

var _FinderToolbar = _interopRequireDefault(require("./FinderToolbar"));

var _FinderBody = _interopRequireDefault(require("./FinderBody"));

var _NavPath = _interopRequireDefault(require("../NavPath/NavPath"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const LayoutFinder = ({
  backgroundColor,
  expanded,
  title,
  parents,
  filters,
  action,
  views,
  search,
  children,
  onSelect
}) => {
  return _react.default.createElement(_FinderBase.default, {
    backgroundColor: backgroundColor,
    expanded: expanded
  }, _react.default.createElement(_FinderHeader.default, {
    backgroundColor: backgroundColor
  }, _react.default.createElement(_NavPath.default, {
    parents: parents,
    title: title,
    filters: filters,
    search: search,
    onSelect: onSelect
  }), action && _react.default.createElement(_FinderToolbar.default, {
    buttons: action
  })), _react.default.createElement(_FinderBody.default, null, children));
};

LayoutFinder.propTypes = process.env.NODE_ENV !== "production" ? {
  backgroundColor: _propTypes.default.string,
  expanded: _propTypes.default.bool,
  title: _propTypes.default.string,
  parents: _propTypes.default.array,
  filters: _propTypes.default.array,
  action: _propTypes.default.array,
  views: _propTypes.default.array,
  search: _propTypes.default.object
} : {};
var _default = LayoutFinder;
exports.default = _default;
module.exports = exports.default;